<template>
  <div v-for="organization in $store.state.data.workspace_organizations" :key="organization.id" class="mt-4">
    <div class="flex space-x-10 w-full">
      <div>{{ organization.name }}</div>

      <div class="cursor-pointer" @click="handleChangeOrganization(organization)">
        <span
          :class="[{ 'opacity-0': $store.state.data.selected_organization?.id !== organization.id }]"
          class="mr-2 mt-1 text-common-grey">{{ $t("Default") }}</span>
        <input
          :disabled="true"
          :checked="$store.state.data.selected_organization?.id == organization.id"
          type="checkbox"
          class="form-checkbox pointer-events-none text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
      </div>
    </div>
  </div>
  <button
    type="button"
    class="mt-10 group inline-flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-light"
    @click="$emit('cancel')">
    {{ $t("Close") }}
  </button>
</template>

<script>
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
export default {
  components: {},
  props: {},
  emits: ["cancel"],
  data() {
    return {}
  },
  watch: {},

  created() {},

  methods: {
    handleChangeOrganization(organization) {
      this.$store.dispatch("data/changeDefaultWorkspaceOrganization", organization)
      this.$emitter.emit(ALL_EMITTERS.WORKSPACE_ORGANIZATION_CHANGED)
    }
  }
}
</script>
